import React from "react";
import "./BlogSpotlight.css";

function BlogSpotlight() {
  return (
    <div className="blogSpotlight">
      <div className="content">
        <h3>Discover Our Latest Posts</h3>
        <p>
          to share thoughts and ideas around the things that actually matter
        </p>
      </div>
    </div>
  );
}

export default BlogSpotlight;
